import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-2"
}
const _hoisted_2 = { class: "text-xl font-bold pt-4" }
const _hoisted_3 = { class: "whitespace-pre-line" }
const _hoisted_4 = { class: "mb-2 font-bold" }
const _hoisted_5 = { class: "text-xl font-bold pt-4" }
const _hoisted_6 = { class: "whitespace-pre-line" }
const _hoisted_7 = { class: "mb-2 font-bold" }
const _hoisted_8 = { class: "text-xl font-bold pt-4" }
const _hoisted_9 = { class: "whitespace-pre-line" }
const _hoisted_10 = { class: "whitespace-pre-line font-bold" }
const _hoisted_11 = { class: "whitespace-pre-line" }

import AccordionComponent from "@/components/accordion/AccordionComponent.vue";
import { inject, ref, watch } from "vue";
import { DestinyMatrix, DestinyMatrixKeysEnum } from "@/types/destinyMatrix";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'PurposesAccordion',
  props: /*@__PURE__*/_mergeModels({
    matrix: {},
    hasPremiumAccess: { type: Boolean }
  }, {
    "modelValue": { type: Boolean, ...{ default: false } },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;
const isOpen = _useModel<boolean>(__props, "modelValue");
const getDescription =
  inject<(key: DestinyMatrixKeysEnum) => Promise<never>>("getDescription");

const { t } = useI18n();

watch(
  () => props.matrix,
  () => (description.value = undefined)
);

const description = ref();

async function getData() {
  if (!props.hasPremiumAccess) {
    isOpen.value = false;
  }
  if (!description.value && props.matrix && getDescription) {
    description.value = await getDescription(DestinyMatrixKeysEnum.PURPOSES);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AccordionComponent, {
    type: "white",
    onOpened: getData,
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
    isBlocked: !__props.hasPremiumAccess
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)("calculators.destiny-matrix.accordions.purposes.title")), 1)
    ]),
    "faq-content": _withCtx(() => [
      (description.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)("calculators.destiny-matrix.accordions.purposes.personal-title", {
              first: __props.matrix.personal.h,
              second: __props.matrix.personal.e,
              third: __props.matrix.personal.social,
            })), 1),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("calculators.destiny-matrix.accordions.purposes.personal-desc")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(description.value['personal'], (personal, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "whitespace-pre-line",
                key: 'personal' + index
              }, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("calculators.destiny-matrix.accordions.purposes.arcane-title", {
                value: index,
              })), 1),
                _createElementVNode("p", null, _toDisplayString(personal), 1)
              ]))
            }), 128)),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)("calculators.destiny-matrix.accordions.purposes.social-title", {
              first: __props.matrix.personal.m,
              second: __props.matrix.personal.f,
              third: __props.matrix.personal.personal,
            })), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)("calculators.destiny-matrix.accordions.purposes.social-desc")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(description.value['social'], (social, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "whitespace-pre-line",
                key: 'social-' + index
              }, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)("calculators.destiny-matrix.accordions.purposes.arcane-title", {
                value: index,
              })), 1),
                _createElementVNode("p", null, _toDisplayString(social), 1)
              ]))
            }), 128)),
            _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)("calculators.destiny-matrix.accordions.purposes.spirit-title", {
              value: __props.matrix.personal.harmony,
            })), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)("calculators.destiny-matrix.accordions.purposes.spirit-desc")), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)("calculators.destiny-matrix.accordions.purposes.spirit-subtitle")), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(description.value["spirit"]), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    "collapse-text-btn": _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)("calculators.destiny-matrix.accordions.collapse")), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "isBlocked"]))
}
}

})